<div class="card">
    <div style="display: inline;">
        <h6>Top Selling Products</h6>

    </div>
    <p-table [value]="topItems" [paginator]="false" [rows]="5" responsiveLayout="scroll"
        [loading]="isTopItemsLoading" [showLoader]="false">
        <ng-template pTemplate="header">
            <tr>
                <th>Image</th>
                <th>Name
                </th>
                <th style="width: 15%; min-width: 8rem;text-align: right;">Sold
                </th>
                <!-- <th>View</th> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4">No data found. </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
            <tr>
                <td colspan="4"><i class="pi pi-spin pi-spinner"></i>&nbsp; Loading products. Please wait.</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td style="width: 4rem;padding: 0.1rem;">
                    <app-available-qty-view style="position: relative;top: 1rem;"
                        [StoreFrontStock]="product.stockQty" [VirtualQuantity]="product.virtualQty" [FbaStock]="product.fbaQty">
                    </app-available-qty-view>
                    <img src="{{getImageUrlForItemId(product,'MainImage')}}" class="shadow-4"
                        alt="{{product.name|ellipsis:'10'}}" width="50">
                </td>
                <td style="width: 80%; min-width: 7rem;padding: 0.1rem;">
                    <div>
                        <small>
                            <!-- <a routerLink="/inventory/products/{{product.itemId}}/inventory">{{product.sku}}</a> -->
                            <app-sku-link [itemId]="product.itemId" [sku]="product.sku"></app-sku-link>
                        </small><span *ngIf="product.quantity>1"> | <span p-tooltip="Total Profit"> {{product.profit|number:'1.2-2'}} </span></span>
                    </div>
                    {{product.name|ellipsis:'80'}}
                    <div class="secondary-text"><img style="width:0.8rem"
                            src="{{getStorefrontImage(product.storefront)}}" />
                        {{product.lastPrice|number:'1.2-2'}}|avg profit:{{product.profit/product.quantity|number:'1.2-2'}}
                    </div>
                </td>
                <td style="width: 15%; min-width: 8rem;text-align: right;padding: 0.1rem;">{{product.quantity}}
                </td>
                <!-- <td style="width: 15%;">
                    <button pButton pRipple type="button" icon="pi pi-search"
                        class="p-button p-component p-button-text p-button-icon-only"></button>
                </td> -->
            </tr>
        </ng-template>
        <!-- <ng-template pTemplate="footer">
           
                
          
        </ng-template> -->
    </p-table>
    <p-checkbox [binary]="true" [(ngModel)]="useNetProfit" (onChange)="getTopSellables()"
        label="Exclude consignment profit share"/>
</div>
